export const INBOX_EN = {
    'notifications.refusal.inbox.not_found': 'No such conversation among those you may see.',
    'notifications.refusal.inbox.party': 'Choose a person from the register.',
    'notifications.refusal.inbox.subject': 'Choose a record.',
    'notifications.refusal.inbox.link_first': 'Link this conversation to a person first.',
    'notifications.refusal.inbox.window_closed': 'More than 24 hours have passed since they last wrote: choose an approved template.',
    'notifications.refusal.inbox.no_address': 'The number this conversation came from cannot be answered on WhatsApp.',
    'notifications.refusal.inbox.assignee': 'This member is not active here, or may not read the inbox.',
    'notifications.refusal.inbox.identity_unavailable': 'The register could not be asked right now. Try again shortly.',
    'change.field.conversation.channel': 'Channel',
    'change.field.conversation.address': 'Number',
    'change.field.conversation.sender_name': 'Name on WhatsApp',
    'change.field.conversation.party_id': 'Person',
    'change.field.conversation.match_state': 'How the person was found',
    'change.field.conversation.status': 'Status',
    'change.field.conversation.assignee_user': 'Assigned to',
    'change.field.conversation.about_entity': 'About (type)',
    'change.field.conversation.about_id': 'About',
    'change.field.conversation.about_origin': 'How it was linked',
    'change.field.conversation.closed_at': 'Closed on',
    'change.field.conversation.closed_by': 'Closed by',
    'conversation.today': 'Today',
    'conversation.yesterday': 'Yesterday',
    'conversation.empty': 'No messages yet.',
    'conversation.nothing': '(no words)',
    'conversation.back': 'Back to the conversation',
    'conversation.open': 'Open the conversation',
    'conversation.reply': 'Your reply',
    'conversation.placeholder': 'Write a reply…',
    'conversation.send': 'Send',
    'conversation.template': 'Template',
    'conversation.template.choose': 'Choose an approved template',
    'conversation.template.none': 'No template has been approved yet',
    'conversation.template.sent': 'Template: {key}',
    'conversation.hidden': 'Hidden for its age: kept, not shown',
    'conversation.redacted': "Erased at the person's request",
    'conversation.status.pending': 'Waiting to go',
    'conversation.status.sent': 'Sent',
    'conversation.status.delivered': 'Delivered',
    'conversation.status.read': 'Read',
    'conversation.status.failed': 'Not delivered',
    'conversation.kind.text': '[Text]',
    'conversation.kind.template': '[Template]',
    'conversation.kind.image': '[Picture]',
    'conversation.kind.document': '[File]',
    'conversation.kind.audio': '[Voice note]',
    'conversation.kind.video': '[Video]',
    'conversation.kind.location': '[Location]',
    'conversation.kind.sticker': '[Sticker]',
    'conversation.kind.contacts': '[Contact card]',
    'conversation.kind.other': '[A message this version cannot show]',
    'nav.notifications.conversations': 'Inbox',
    'notifications.conversations.title': 'Inbox',
    'notifications.conversations.lede': "What people wrote back on WhatsApp: yours, nobody's yet, and the rest.",
    'notifications.conversations.stat.open': 'Open',
    'notifications.conversations.stat.waiting': 'Waiting for an answer',
    'notifications.conversations.stat.unassigned': 'Nobody has it',
    'notifications.conversations.stat.mine': 'Mine',
    'notifications.conversations.col.who': 'From',
    'notifications.conversations.col.queue': 'Queue',
    'notifications.conversations.col.waiting': 'Waiting for an answer',
    'notifications.conversations.col.assignee': 'Assigned to',
    'notifications.conversations.col.last_message_at': 'Last message',
    'notifications.conversations.col.match_state': 'Person',
    'notifications.conversations.col.about': 'About',
    'notifications.conversations.col.last_preview': 'Last words',
    'notifications.conversations.queue.mine': 'Mine',
    'notifications.conversations.queue.unassigned': 'Nobody has it',
    'notifications.conversations.queue.others': "Someone else's",
    'notifications.conversations.queue.closed': 'Closed',
    'notifications.conversations.action.open': 'Open the conversation',
    'notifications.conversations.empty': "Nobody has written to the workspace's WhatsApp number yet.",
    'notifications.conversation.title': 'Conversation',
    'notifications.conversation.lede': 'What they wrote and what was answered, with the person and the record it is about.',
    'notifications.conversation.no_id': 'No conversation chosen',
    'notifications.conversation.no_id.hint': 'Open a conversation from the inbox.',
    'notifications.conversation.unknown': 'Unknown sender',
    'notifications.conversation.about': 'About: {record}',
    'notifications.conversation.about.label': 'About',
    'notifications.conversation.about.choose': 'Link to a record',
    'notifications.conversation.about.change': 'Change',
    'notifications.conversation.about.inherited': 'From the message they answered',
    'notifications.conversation.about.title': 'Choose the record',
    'notifications.conversation.about.hint': 'Search the records you may open, by name or number. The conversation then shows on that record\'s page.',
    'notifications.conversation.about.search': 'Search records',
    'notifications.conversation.about.short': 'Type at least two letters.',
    'notifications.conversation.about.none': 'No record matches.',
    'notifications.conversation.about.unavailable': 'Records cannot be searched here.',
    'notifications.conversation.about.save': 'Link',
    'notifications.conversation.about.clear': 'Remove the link',
    'notifications.conversation.about.saved': 'Linked to the record.',
    'notifications.conversation.about.cleared': 'No longer linked to a record.',
    'notifications.conversation.state.waiting': 'Waiting for an answer',
    'notifications.conversation.state.answered': 'Answered',
    'notifications.conversation.state.closed': 'Closed',
    'notifications.conversation.assignee': 'Assigned to',
    'notifications.conversation.assignee.nobody': 'Nobody',
    'notifications.conversation.assigned': 'Given to {who}.',
    'notifications.conversation.released': 'Put back for anybody to take.',
    'notifications.conversation.close': 'Close',
    'notifications.conversation.closed': 'Closed. A new message from them opens it again.',
    'notifications.conversation.reopen': 'Reopen',
    'notifications.conversation.window.open': 'The window is open: {hours} h {minutes} min left to answer in your own words.',
    'notifications.conversation.window.closed': 'More than 24 hours have passed since they last wrote: WhatsApp carries only an approved template now.',
    'notifications.conversation.window.link_first': 'Link this number to a person before answering.',
    'notifications.conversation.template.missing': 'Fill in {name}.',
    'notifications.conversation.person': 'The person',
    'notifications.conversation.person.open': 'Open their page',
    'notifications.conversation.whatsapp_name': 'On WhatsApp: {name}',
    'notifications.conversation.match.matched': 'Found by number',
    'notifications.conversation.match.linked': 'Linked by a member',
    'notifications.conversation.match.unknown': 'Not on the register',
    'notifications.conversation.match.ambiguous': 'More than one person has this number',
    'notifications.conversation.link': 'Link to a person',
    'notifications.conversation.link.change': 'Link to someone else',
    'notifications.conversation.link.title': 'Who is this?',
    'notifications.conversation.link.hint': 'Choose the person on the register this number belongs to. What they wrote before stays with the conversation.',
    'notifications.conversation.link.search': 'Search by name',
    'notifications.conversation.link.none': 'Nobody on the register by that name.',
    'notifications.conversation.link.save': 'Link',
    'notifications.conversation.linked': 'Linked.',
    'notifications.party_conversations.title': 'WhatsApp conversations',
    'notifications.party_conversations.empty': 'They have not written to the workspace on WhatsApp.',
    'notifications.subject_conversations.title': 'Conversations about this',
    'notifications.subject_conversations.empty': 'No conversation has been linked to this record.',
    'entity.notifications.subject': 'Conversations',
    'notifications.inbox_settings.title': 'Inbox',
    'notifications.inbox_settings.col.unanswered_minutes': 'Announced unanswered after (minutes)',
    'notifications.inbox_settings.col.retention_days': 'Words kept in view (days)',
    'notifications.inbox_settings.note': 'Nothing is deleted: older words are hidden from view and kept.',
    'notifications.inbox_settings.action.edit': 'Change',
    'notifications.inbox_settings.field.unanswered_minutes': 'Announce a message unanswered after (minutes)',
    'notifications.inbox_settings.field.unanswered_minutes.help': 'From 5 minutes to a day. 30 when nobody chose.',
    'notifications.inbox_settings.field.retention_days': "Keep a message's words in view for (days)",
    'notifications.inbox_settings.field.retention_days.help': 'From 30 days to ten years. Two years (730) when nobody chose.',
    'notifications.refusal.inbox.setting_range': 'Enter a whole number within the range shown.',
    'change.field.conversation.party_name': "Person's name",
    'change.field.inbox_settings.unanswered_minutes': 'Announced unanswered after (minutes)',
    'change.field.inbox_settings.retention_days': 'Words kept in view (days)',
    // Inbound email (docs/design/inbound-email.md): the inbox's second channel.
    'notifications.refusal.inbox.email_reply': 'Answering by email from the inbox is not available yet: reply from your own mail.',
    'notifications.refusal.webhook.stale': 'The request is more than five minutes old.',
    'notifications.refusal.email.inactive': 'This inbound address is not active: nothing was kept.',
    'notifications.refusal.email.unreadable': 'This is not a mail: a sender and a recipient are required.',
    'notifications.refusal.email.too_many': 'Too many mails in the last minute. Try again shortly.',
    'notifications.refusal.email.address': 'Enter an email address.',
    'notifications.refusal.email.slug': 'Use 1 to 30 Latin letters, digits or dashes.',
    'notifications.refusal.email.mailbox': 'No such receiving address in this workspace.',
    'notifications.refusal.email.retired': 'This receiving address is retired.',
    'notifications.refusal.email.stale': 'Somebody changed this receiving address since you opened it. Open it again.',
    'notifications.refusal.connection.setting.trust_auth_results': 'Yes or no.',
    'change.field.conversation.mailbox_id': 'Receiving address',
    'change.field.conversation.thread_token': 'Reply address',
    'change.field.mailbox.label': 'Name',
    'change.field.mailbox.displayed_address': 'Public address',
    'change.field.mailbox.local_part': 'Receiving address',
    'change.field.mailbox.domain': 'Receiving domain',
    'change.field.mailbox.address_issued_at': 'Address issued on',
    'change.field.mailbox.status': 'Status',
    'change.field.mailbox.created_by': 'Created by',
};
export const INBOX_AR = {
    'notifications.refusal.inbox.not_found': 'لا توجد محادثة كهذه بين ما يحق لك رؤيته.',
    'notifications.refusal.inbox.party': 'اختر طرفًا من السجل.',
    'notifications.refusal.inbox.subject': 'اختر سجلًّا.',
    'notifications.refusal.inbox.link_first': 'اربط المحادثة بطرف أولًا.',
    'notifications.refusal.inbox.window_closed': 'مضى أكثر من 24 ساعة على آخر رسالة منه، فاختر قالبًا معتمدًا.',
    'notifications.refusal.inbox.no_address': 'لا يمكن الرد على الرقم الذي جاءت منه المحادثة عبر واتساب.',
    'notifications.refusal.inbox.assignee': 'هذا العضو غير نشط هنا، أو لا يملك قراءة الوارد.',
    'notifications.refusal.inbox.identity_unavailable': 'تعذّر سؤال السجل الآن. حاول بعد قليل.',
    'change.field.conversation.channel': 'القناة',
    'change.field.conversation.address': 'الرقم',
    'change.field.conversation.sender_name': 'الاسم في واتساب',
    'change.field.conversation.party_id': 'الطرف',
    'change.field.conversation.match_state': 'طريقة التعرّف على الطرف',
    'change.field.conversation.status': 'الحالة',
    'change.field.conversation.assignee_user': 'مسندة إلى',
    'change.field.conversation.about_entity': 'نوع السجل المرتبط',
    'change.field.conversation.about_id': 'السجل المرتبط',
    'change.field.conversation.about_origin': 'طريقة الربط',
    'change.field.conversation.closed_at': 'أُغلقت في',
    'change.field.conversation.closed_by': 'أغلقها',
    'conversation.today': 'اليوم',
    'conversation.yesterday': 'أمس',
    'conversation.empty': 'لا رسائل بعد.',
    'conversation.nothing': '(بلا كلمات)',
    'conversation.back': 'العودة إلى المحادثة',
    'conversation.open': 'فتح المحادثة',
    'conversation.reply': 'ردّك',
    'conversation.placeholder': 'اكتب ردًّا…',
    'conversation.send': 'إرسال',
    'conversation.template': 'القالب',
    'conversation.template.choose': 'اختر قالبًا معتمدًا',
    'conversation.template.none': 'لم يُعتمد أي قالب بعد',
    'conversation.template.sent': 'قالب: {key}',
    'conversation.hidden': 'مخفية لقِدَمها: محفوظة ولا تُعرض',
    'conversation.redacted': 'حُذفت بطلب صاحبها',
    'conversation.status.pending': 'بانتظار الإرسال',
    'conversation.status.sent': 'أُرسلت',
    'conversation.status.delivered': 'وصلت',
    'conversation.status.read': 'قُرئت',
    'conversation.status.failed': 'لم تصل',
    'conversation.kind.text': '[نص]',
    'conversation.kind.template': '[قالب]',
    'conversation.kind.image': '[صورة]',
    'conversation.kind.document': '[ملف]',
    'conversation.kind.audio': '[رسالة صوتية]',
    'conversation.kind.video': '[فيديو]',
    'conversation.kind.location': '[موقع]',
    'conversation.kind.sticker': '[ملصق]',
    'conversation.kind.contacts': '[بطاقة جهة اتصال]',
    'conversation.kind.other': '[رسالة لا يعرضها هذا الإصدار]',
    'nav.notifications.conversations': 'صندوق الوارد',
    'notifications.conversations.title': 'صندوق الوارد',
    'notifications.conversations.lede': 'ما ردّ به الناس على واتساب: محادثاتك، وما لم يستلمه أحد، والباقي.',
    'notifications.conversations.stat.open': 'مفتوحة',
    'notifications.conversations.stat.waiting': 'بانتظار رد',
    'notifications.conversations.stat.unassigned': 'غير مسندة',
    'notifications.conversations.stat.mine': 'لي',
    'notifications.conversations.col.who': 'من',
    'notifications.conversations.col.queue': 'الطابور',
    'notifications.conversations.col.waiting': 'بانتظار رد',
    'notifications.conversations.col.assignee': 'المسند إليه',
    'notifications.conversations.col.last_message_at': 'آخر رسالة',
    'notifications.conversations.col.match_state': 'الطرف',
    'notifications.conversations.col.about': 'السجل المرتبط',
    'notifications.conversations.col.last_preview': 'آخر ما كُتب',
    'notifications.conversations.queue.mine': 'لي',
    'notifications.conversations.queue.unassigned': 'غير مسندة',
    'notifications.conversations.queue.others': 'لغيري',
    'notifications.conversations.queue.closed': 'مغلقة',
    'notifications.conversations.action.open': 'فتح المحادثة',
    'notifications.conversations.empty': 'لم يكتب أحد إلى رقم واتساب المساحة بعد.',
    'notifications.conversation.title': 'المحادثة',
    'notifications.conversation.lede': 'ما كتبه وما رُدّ عليه، مع الطرف والسجل المرتبط.',
    'notifications.conversation.no_id': 'لم تُختر محادثة',
    'notifications.conversation.no_id.hint': 'افتح محادثة من صندوق الوارد.',
    'notifications.conversation.unknown': 'مرسل غير معروف',
    'notifications.conversation.about': 'مرتبطة بـ: {record}',
    'notifications.conversation.about.label': 'يخص',
    'notifications.conversation.about.choose': 'ربط بسجل',
    'notifications.conversation.about.change': 'تغيير',
    'notifications.conversation.about.inherited': 'من الرسالة التي ردّ عليها',
    'notifications.conversation.about.title': 'اختر السجل',
    'notifications.conversation.about.hint': 'ابحث في السجلات التي يحق لك فتحها بالاسم أو الرقم. تظهر المحادثة بعدها في صفحة ذلك السجل.',
    'notifications.conversation.about.search': 'ابحث عن سجل',
    'notifications.conversation.about.short': 'اكتب حرفين على الأقل.',
    'notifications.conversation.about.none': 'لا سجل يطابق.',
    'notifications.conversation.about.unavailable': 'لا يمكن البحث في السجلات هنا.',
    'notifications.conversation.about.save': 'ربط',
    'notifications.conversation.about.clear': 'إزالة الربط',
    'notifications.conversation.about.saved': 'رُبطت بالسجل.',
    'notifications.conversation.about.cleared': 'لم تعد مرتبطة بسجل.',
    'notifications.conversation.state.waiting': 'بانتظار رد',
    'notifications.conversation.state.answered': 'رُدّ عليها',
    'notifications.conversation.state.closed': 'مغلقة',
    'notifications.conversation.assignee': 'المسند إليه',
    'notifications.conversation.assignee.nobody': 'لا أحد',
    'notifications.conversation.assigned': 'أُسندت إلى {who}.',
    'notifications.conversation.released': 'أُعيدت ليستلمها أي أحد.',
    'notifications.conversation.close': 'إغلاق',
    'notifications.conversation.closed': 'أُغلقت. تُفتح من جديد إذا كتب مرة أخرى.',
    'notifications.conversation.reopen': 'إعادة فتح',
    'notifications.conversation.window.open': 'النافذة مفتوحة: {hours} س {minutes} د متبقية للرد بنص حر.',
    'notifications.conversation.window.closed': 'مضى أكثر من 24 ساعة على آخر رسالة منه، فلا يحمل واتساب الآن إلا قالبًا معتمدًا.',
    'notifications.conversation.window.link_first': 'اربط هذا الرقم بطرف قبل الرد.',
    'notifications.conversation.template.missing': 'املأ {name}.',
    'notifications.conversation.person': 'الطرف',
    'notifications.conversation.person.open': 'فتح صفحته',
    'notifications.conversation.whatsapp_name': 'على واتساب: {name}',
    'notifications.conversation.match.matched': 'عُرف من الرقم',
    'notifications.conversation.match.linked': 'ربطه عضو',
    'notifications.conversation.match.unknown': 'ليس في السجل',
    'notifications.conversation.match.ambiguous': 'الرقم لأكثر من طرف',
    'notifications.conversation.link': 'ربط بطرف',
    'notifications.conversation.link.change': 'ربط بطرف آخر',
    'notifications.conversation.link.title': 'من صاحب هذا الرقم؟',
    'notifications.conversation.link.hint': 'اختر الطرف من السجل. ما كتبه من قبل يبقى في المحادثة.',
    'notifications.conversation.link.search': 'ابحث بالاسم',
    'notifications.conversation.link.none': 'لا أحد في السجل بهذا الاسم.',
    'notifications.conversation.link.save': 'ربط',
    'notifications.conversation.linked': 'رُبطت.',
    'notifications.party_conversations.title': 'محادثات واتساب',
    'notifications.party_conversations.empty': 'لم يكتب إلى المساحة على واتساب.',
    'notifications.subject_conversations.title': 'المحادثات حول هذا السجل',
    'notifications.subject_conversations.empty': 'لم تُربط محادثة بهذا السجل.',
    'entity.notifications.subject': 'المحادثات',
    'notifications.inbox_settings.title': 'صندوق الوارد',
    'notifications.inbox_settings.col.unanswered_minutes': 'التنبيه بعدم الرد بعد (دقائق)',
    'notifications.inbox_settings.col.retention_days': 'مدة عرض نصوص الرسائل (أيام)',
    'notifications.inbox_settings.note': 'لا يُحذف شيء: النصوص الأقدم تُخفى من العرض وتبقى محفوظة.',
    'notifications.inbox_settings.action.edit': 'تغيير',
    'notifications.inbox_settings.field.unanswered_minutes': 'نبّه بعدم الرد على الرسالة بعد (دقائق)',
    'notifications.inbox_settings.field.unanswered_minutes.help': 'من 5 دقائق إلى يوم. 30 إن لم يختر أحد.',
    'notifications.inbox_settings.field.retention_days': 'اعرض نصوص الرسائل مدة (أيام)',
    'notifications.inbox_settings.field.retention_days.help': 'من 30 يومًا إلى عشر سنوات. سنتان (730) إن لم يختر أحد.',
    'notifications.refusal.inbox.setting_range': 'أدخل عددًا صحيحًا ضمن المدى المبيّن.',
    'change.field.conversation.party_name': 'اسم الطرف',
    'change.field.inbox_settings.unanswered_minutes': 'التنبيه بعدم الرد بعد (دقائق)',
    'change.field.inbox_settings.retention_days': 'مدة عرض النصوص (أيام)',
    // البريد الوارد: القناة الثانية في صندوق الوارد.
    'notifications.refusal.inbox.email_reply': 'الرد بالبريد من صندوق الوارد غير متاح بعد، فردّ من بريدك.',
    'notifications.refusal.webhook.stale': 'مضى على الطلب أكثر من خمس دقائق.',
    'notifications.refusal.email.inactive': 'عنوان الاستقبال هذا غير مفعّل، فلم يُحفظ شيء.',
    'notifications.refusal.email.unreadable': 'هذه ليست رسالة بريد: يلزم المرسل والمستلم.',
    'notifications.refusal.email.too_many': 'رسائل كثيرة في الدقيقة الأخيرة. حاول بعد قليل.',
    'notifications.refusal.email.address': 'أدخل عنوان بريد إلكتروني.',
    'notifications.refusal.email.slug': 'استخدم من 1 إلى 30 حرفًا لاتينيًا أو رقمًا أو شرطة.',
    'notifications.refusal.email.mailbox': 'لا يوجد عنوان استقبال كهذا في هذه المساحة.',
    'notifications.refusal.email.retired': 'عنوان الاستقبال هذا متوقف.',
    'notifications.refusal.email.stale': 'غيّر أحدهم عنوان الاستقبال منذ فتحته. افتحه من جديد.',
    'notifications.refusal.connection.setting.trust_auth_results': 'نعم أو لا.',
    'change.field.conversation.mailbox_id': 'عنوان الاستقبال',
    'change.field.conversation.thread_token': 'عنوان الرد',
    'change.field.mailbox.label': 'الاسم',
    'change.field.mailbox.displayed_address': 'العنوان العام',
    'change.field.mailbox.local_part': 'عنوان الاستقبال',
    'change.field.mailbox.domain': 'نطاق الاستقبال',
    'change.field.mailbox.address_issued_at': 'تاريخ إصدار العنوان',
    'change.field.mailbox.status': 'الحالة',
    'change.field.mailbox.created_by': 'أنشأه',
};
//# sourceMappingURL=i18n-inbox.js.map